import { Component } from '@verndale/core';

import Modal from './modal';

class Module extends Component {
  setupDefaults() {
    this.dom = {
      widget: this.el.querySelector('.cookie-banner__widget'),
      showDetails: this.el.querySelector('.cookie-banner__widget-show-details'),
      modal: this.el.querySelector('.cookie-banner__details')
    };

    this.modal = new Modal(this.dom.modal);
  }

  addListeners() {
    this.dom.showDetails.addEventListener(
      'click',
      this.handleOpenDescription.bind(this)
    );
  }

  handleOpenDescription(e) {
    e.preventDefault();
    this.modal.open();
    this.hideWidget();
  }

  showWidget() {
    this.dom.widget.style.bottom = '0px';
  }

  hideWidget() {
    this.dom.widget.style.bottom = '-100%';

    setTimeout(() => {
      this.dom.widget.style.display = 'none';
    }, 700);
  }

  show() {
    this.showWidget();
  }

  hide() {
    this.modal.close();
    this.hideWidget();
  }
}

export default Module;
